import React from 'react';
import styled from 'styled-components';
import { RadixSelect } from 'components/common/RadixSelect/RadixSelect';

interface OptionType {
  readonly label: string;
  readonly value: string;
}

interface ResourcesDropdownProps {
  readonly selectedResourceId: string;
  readonly options: OptionType[];
  readonly onChange: (option: OptionType) => void;
  readonly portalContainer?: HTMLElement | null;
}

// Styled wrapper to match the participants dropdown dimensions
const StyledResourcesDropdown = styled.div`
  width: 175px;
`;

export const ResourcesDropdown: React.FC<ResourcesDropdownProps> = ({
  selectedResourceId,
  options,
  onChange,
  portalContainer,
}) => {
  const handleValueChange = (selectedValue: string | number) => {
    const selectedOption = options.find(
      (option) => option.value === selectedValue.toString(),
    );
    if (selectedOption) {
      onChange(selectedOption);
    }
  };

  return (
    <StyledResourcesDropdown>
      <RadixSelect
        options={options}
        value={selectedResourceId}
        onValueChange={handleValueChange}
        placeholder=""
        portalContainer={portalContainer}
      />
    </StyledResourcesDropdown>
  );
};
